import React from "react";
import { ResourceIdentifier } from "@design-controls/types";

export function qriColumn<
  T extends { component?: ResourceIdentifier; category?: ResourceIdentifier },
>(
  id: "component" | "category",
  accessorFn: (d: T) => string | undefined,
  header: string,
) {
  return {
    id,
    accessorFn,
    header,
    meta: {
      maxWidth: "200px",
    },
    cell: ({ row: { original: row } }: { row: { original: T } }) => (
      <>{row[id]?.label}</>
    ),
    sortingFn: (a: any, b: any, columnId: string) => {
      const aVal = a.getValue(columnId) as string | undefined;
      const bVal = b.getValue(columnId) as string | undefined;

      if (!aVal) {
        return 1;
      }

      if (!bVal) {
        return -1;
      }

      return aVal.toLocaleLowerCase().localeCompare(bVal?.toLocaleLowerCase());
    },
    sortUndefined: "last",
    enableSorting: true,
  };
}
